function generateCustomElementClass() {
    return class extends HTMLElement {
        connectedCallback() {
            this.innerHTML = `\n        <div class="referral-program__trigger-wrapper">\n        <div class="dropdown-button tw-cursor-pointer header-h6">\n        ${referal_translations.heading}\n        <span class="collapsible-icon collapsible-trigger__icon--open" role="presentation">\n        <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n        <path d="M8.11519 7.99469C8.29154 7.97079 8.45652 7.89645 8.58737 7.77962L15.6985 1.40458C16.0597 1.12048 16.1052 0.618653 15.8009 0.281447C15.4965 -0.055758 14.9589 -0.0982406 14.5977 0.185862C14.5721 0.207103 14.5493 0.228344 14.5266 0.249586L8.00141 6.09891L1.47626 0.252241C1.15483 -0.0690338 0.614389 -0.0849647 0.270211 0.215068C-0.0739668 0.515102 -0.0910334 1.01958 0.230389 1.34086C0.253144 1.36475 0.2759 1.38599 0.3015 1.40458L7.41261 7.77697C7.60034 7.94424 7.85919 8.0239 8.11519 7.99203V7.99469Z" fill="#1B1B1B"/>\n        </svg>\n        </span>\n        </div>\n        <a href="/pages/referral-page" class="referral-program__trigger-icon">\n            <?xml version="1.0" encoding="iso-8859-1"?>\n            \x3c!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools --\x3e\n            <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n            <g clip-path="url(#clip0_1007_367)">\n            <path d="M10 0.18866C15.4189 0.18866 19.8114 4.58111 19.8114 9.99998C19.8114 15.4188 15.4189 19.8113 10 19.8113C4.58117 19.8113 0.188721 15.4188 0.188721 9.99998C0.188721 4.58111 4.58117 0.18866 10 0.18866ZM10 18.3019C14.5887 18.3019 18.3019 14.5887 18.3019 9.99998C18.3019 5.4113 14.5887 1.69809 10 1.69809C5.41136 1.69809 1.69815 5.4113 1.69815 9.99998C1.69815 14.5887 5.41136 18.3019 10 18.3019Z" fill="#6867F9" stroke="#6867F9" stroke-width="0.5" stroke-miterlimit="10"/>\n            <path d="M6.70947 7.66793C6.70947 4.9434 8.72457 4.21887 9.88683 4.21887C11.6831 4.12831 13.2076 5.50944 13.2982 7.30566C13.2982 7.42642 13.2982 7.55472 13.2982 7.67548C13.2982 9.11699 12.2491 10.1887 11.5548 10.8679C11.3963 11.0264 11.2453 11.1774 11.1321 11.3132C10.8755 11.7057 10.7472 12.166 10.7623 12.634C10.7774 13.0491 10.4529 13.3962 10.0378 13.4189H10.0076C9.60004 13.4189 9.26796 13.1019 9.25287 12.6943C9.23023 11.8491 9.49438 11.0189 10.0076 10.3396C10.1434 10.1811 10.317 10 10.5132 9.81133C11.0944 9.23019 11.8114 8.50566 11.8114 7.68302C11.8114 5.99246 10.6265 5.7434 9.91702 5.7434C9.52457 5.7434 8.2491 5.8868 8.2491 7.68302C8.2491 8.09812 7.90947 8.43774 7.49438 8.43774C7.07928 8.43774 6.73966 8.09812 6.73966 7.68302H6.71702L6.70947 7.66793Z" fill="#6867F9" stroke="#6867F9" stroke-width="0.5" stroke-miterlimit="10"/>\n            <path d="M10.5284 14.5358C10.6642 14.6717 10.7397 14.8528 10.7472 15.0415C10.7472 15.4566 10.4076 15.7962 9.99251 15.7962C9.78874 15.7962 9.60006 15.7132 9.45666 15.5774C9.31326 15.434 9.23779 15.2453 9.23779 15.0415C9.24534 14.8528 9.32836 14.6717 9.45666 14.5358C9.75855 14.2566 10.2265 14.2566 10.5208 14.5358H10.5284Z" fill="#6867F9" stroke="#6867F9" stroke-width="0.5" stroke-miterlimit="10"/>\n            </g>\n            <defs>\n            <clipPath id="clip0_1007_367">\n            <rect width="20" height="20" fill="white"/>\n            </clipPath>\n            </defs>\n            </svg>\n        </a>\n        </div>\n        <div class="dropdown-content" style="display: none;">\n          <div class="custom-input-wrapper__title">\n              <p class="custom-input-wrapper__title-first paragraph-p3" >${referal_translations.title}</p>\n              <p class="custom-input-wrapper__title-second paragraph-p3" >${referal_translations.title_2}</p>\n          </div>\n          <div class="custom-input-wrapper" id="custom-form">\n              <div style="display: none;" id="email-check">\n                  <input type="email" id="check-email" placeholder="${referal_translations.step_1_email}">\n                  <button type="button" id="check-email-button" class="paragraph-p5">${referal_translations.submit_button}</button>\n              </div>\n              <div id="check-email-response"></div>\n              <div class="flex__wrapper" style="display: none;">\n                <input type="text" id="custom-input" placeholder="${referal_translations.input_placeholder}">\n                <button type="submit" id="custom-submit">${referal_translations.submit_button}</button>\n              </div>\n              <div id="custom-response"></div>\n          </div>\n        </div>\n        <div class="custom-input-wrapper__text header-h6">\n            <h6>${referal_translations.text}</h6>\n        </div>\n        `;
            const inputElement = this.querySelector("#custom-input");
            const submitButton = this.querySelector("#custom-submit");
            const responseElement = this.querySelector("#custom-response");
            const flexWrapper = this.querySelector(".flex__wrapper");
            const serverurl = "https://heyholy-referral.fly.dev";
            const checkMailResponse = this.querySelector("#check-email-response");
            const first_title = this.querySelector(".custom-input-wrapper__title-first");
            const second_title = this.querySelector(".custom-input-wrapper__title-second");
            const emailCheckDiv = this.querySelector("#email-check");
            const checkEmailElement = this.querySelector("#check-email");
            const checkEmailButton = this.querySelector("#check-email-button");
            const checkEmailResponseElement = this.querySelector("#check-email-response");
            const dropdownButton = this.querySelector(".dropdown-button");
            const dropdownContent = this.querySelector(".dropdown-content");
            const collapsibleIcon = this.querySelector(".collapsible-icon");
            const shop = "heyholy-com.myshopify.com";

            dropdownButton.addEventListener("click", () => {
                if (dropdownContent.style.display === "none") {
                    dropdownContent.style.display = "block";
                    collapsibleIcon.style.transform = "rotate(180deg)";
                    dropdownContent.classList.add("showing");
                } else {
                    dropdownContent.style.display = "none";
                    collapsibleIcon.style.transform = "rotate(0deg)";
                    dropdownContent.classList.remove("showing");
                }
            });
            if (sessionStorage.getItem("customerExists") === "true") {
                emailCheckDiv.style.display = "none";
                emailCheckDiv.classList.remove("custom-input-wrapper__flex");
                flexWrapper.style.display = "none";
                flexWrapper.classList.remove("custom-input-wrapper__flex");
                first_title.style.display = "none";
                second_title.style.display = "none";
                document.querySelector(".referral-program__trigger-wrapper").style.display = "none";
                document.querySelector(".referral-program__trigger-wrapper").style.visibility = "hidden";
                document.querySelector(".referral-program__trigger-wrapper").style.height = "0";
                document.querySelector(".referral-program__trigger-wrapper").style.opacity = "0";
            } else if (sessionStorage.getItem("customerExists") === "false") {
                emailCheckDiv.style.display = "none";
                emailCheckDiv.classList.remove("custom-input-wrapper__flex");
                flexWrapper.style.display = "flex";
                flexWrapper.classList.add("custom-input-wrapper__flex");
                first_title.style.display = "block";
                second_title.style.display = "none";
            } else {
                emailCheckDiv.style.display = "flex";
                emailCheckDiv.classList.add("custom-input-wrapper__flex");
                flexWrapper.style.display = "none";
                flexWrapper.classList.remove("custom-input-wrapper__flex");
                first_title.style.display = "none";
                second_title.style.display = "block";
            }
            function validateEmail(email) {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            }
            checkEmailButton.addEventListener("click", (e) => {
                e.preventDefault();
                const emailValue = checkEmailElement.value;
                if (emailValue) {
                    if (!validateEmail(emailValue)) {
                        checkEmailResponseElement.textContent = referal_translations.provide_an_email;
                        checkEmailResponseElement.style.color = "red";
                        return;
                    }
                    const checkCustomerUrl = `${serverurl}/app/check-customer?_data=routes/app.check-customer`;
                    fetch(checkCustomerUrl, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ email: emailValue, shop: shop })
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("Success:", data);
                            if (data.customerExists) {
                                sessionStorage.setItem("customerExists", "true");
                                emailCheckDiv.style.display = "none";
                                emailCheckDiv.classList.remove("custom-input-wrapper__flex");
                                flexWrapper.style.display = "none";
                                flexWrapper.classList.remove("custom-input-wrapper__flex");
                                first_title.style.display = "none";
                                second_title.style.display = "none";
                                checkMailResponse.textContent = referal_translations.email_exists;
                            } else {
                                sessionStorage.setItem("customerExists", "false");
                                emailCheckDiv.style.display = "none";
                                emailCheckDiv.classList.remove("custom-input-wrapper__flex");
                                flexWrapper.style.display = "flex";
                                flexWrapper.classList.add("custom-input-wrapper__flex");
                                first_title.style.display = "block";
                                second_title.style.display = "none";
                                checkMailResponse.style.color = "#036863";
                                checkMailResponse.style.display = "none";
                                setTimeout(function () {
                                    checkMailResponse.style.display = "none";
                                }, 2e3);
                            }
                        })
                        .catch((error) => {
                            console.error("Error:", error);
                        });
                } else {
                    checkEmailResponseElement.textContent = referal_translations.error_text_3;
                    checkEmailResponseElement.style.color = "red";
                }
            });
            inputElement.addEventListener("input", function () {
                const words = this.value.split(" ");
                if (words.length > 2) {
                    this.value = words.slice(0, 2).join(" ");
                }
            });
            submitButton.addEventListener("click", (e) => {
                e.preventDefault();
                const value = inputElement.value;
                const newCustomerEmail = checkEmailElement.value
                if (value) {
                    console.log("Submitted value:", value);
                    let referalurl;
                    if (value.indexOf("@") > -1) {
                        referalurl = `${serverurl}/search-customer?email=${value}`;
                    } else {
                        referalurl = `${serverurl}/search-customer?firstName=${value.split(" ")[0]}&lastName=${value.split(" ")[1]}`;
                    }
                    const searchCustomerUrl = `${serverurl}/app/search-customer?_data=routes/app.search-customer`;
                    fetch(searchCustomerUrl, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ email: value, shop: shop, newCustomerEmail: newCustomerEmail })
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("Success:", data);
                            console.log("Success message:", data.message);
                            const message = data.message;
                            console.log("message", message);
                            if (message.includes('FRIEND')) {
                                responseElement.textContent = referal_translations.success_text;
                                responseElement.style.color = "#036863";
                                const inputField = document.querySelector(".docapp-coupon-input--input");
                                const submitButton = document.querySelector(".docapp-coupon-input--button");
                                inputField.value = data.message;
                                submitButton.click();
                                if (window.location.href.indexOf("cart") > -1) {
                                    setReferralInput(".docapp-cart-with-coupon-summary", "custom-input-cart");
                                } else {
                                    setReferralInput("#slidecarthq .footer");
                                }
                                if (document.querySelector(".docapp-coupon-input--bean-container--bean-remove")) {
                                    setTimeout(function () {
                                        document.querySelectorAll(".docapp-coupon-input--bean-container--bean-remove").forEach((discount) => {
                                            discount.addEventListener("click", setReferralInput("#slidecarthq .footer"));
                                        });
                                    }, 2e3);
                                }
                            }
                            if (message === "Customer not found") {
                                responseElement.textContent = referal_translations.error_text;
                                responseElement.style.color = "red";
                                inputElement.placeholder = referal_translations.email_placeholder;
                            }
                            if (message === "Customer's email not found") {
                                responseElement.textContent = referal_translations.error_text_2;
                                responseElement.style.color = "red";
                                console.log("error 2");
                            }
                            if (message === "Multiple customers found with the same name, please provide an email") {
                                responseElement.textContent = referal_translations.error_text_5;
                                responseElement.style.color = "red";
                                console.log("error 5");
                            }
                            if (message === `Customer is found, but he doesn't have any orders`) {
                                responseElement.textContent = referal_translations.error_text_4;
                                responseElement.style.color = "red";
                                console.log("error 4");
                            }
                        })
                        .catch((error) => {
                            console.error("Error:", error);
                        });
                } else {
                    responseElement.textContent = referal_translations.error_text_3;
                    responseElement.style.color = "red";
                }
            });
        }
    };
}
const slideCartEventsRef = ["SLIDECART_UPDATED", "SLIDECART_ADD_TO_CART", "SLIDECART_OPENED", "SLIDECART_CLOSED", "SLIDECART_REMOVED_FROM_CART", "SLIDECART_CHECKOUT", "SLIDECART_UPSELL_ADD", "SLIDECART_LOADED"];
slideCartEventsRef.forEach((event) => (window[event] = setReferralInput("#slidecarthq .footer")));
function setReferralInput(selector, inputName = "custom-input") {
    setTimeout(function () {
        if (document.querySelector(selector)) {
            const footerElement = document.querySelector(selector);
            document.querySelectorAll(inputName).forEach((el) => el.remove());
            if (!customElements.get(inputName)) {
                customElements.define(inputName, generateCustomElementClass());
            }
            const customInputElement = document.createElement(inputName);
            footerElement.insertBefore(customInputElement, footerElement.firstChild);
        }
    }, 800);
}
function waitForElm(selector) {
    return new Promise((resolve) => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    });
}
if (window.location.href.indexOf("cart") > -1) {
    waitForElm(".docapp-cart-with-coupon-summary").then(() => {
        setTimeout(function () {
            setReferralInput(".docapp-cart-with-coupon-summary", "custom-input-cart");
        }, 1500);
    });
}
setInterval(() => {
    if (window.location.href.indexOf("cart") > -1) {
        if (!document.querySelector(".docapp-cart-with-coupon-summary custom-input-cart")) {
            setReferralInput(".docapp-cart-with-coupon-summary", "custom-input-cart");
        }
    } else {
        if (!document.querySelector(".docapp-cart-with-coupon-summary custom-input")) {
            setReferralInput(".docapp-cart-with-coupon-summary", "custom-input");
        }
    }
}, 3500);
